import React, {useEffect} from "react";

const CalendarTime = (props) => {
    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();

        return () => {
            $('[data-toggle="tooltip"]').tooltip("hide");
        };
    }, []);

    const curTimeIdx = props.day.items.findIndex(i => i.value == props.time);

    const curTime = props.day.items[curTimeIdx];

    let tdClasses = [];
    let tdRowSpan = null;
    let reservedItemInterval = null;
    let removeItem = null;

    switch (curTime.status) {
        case "free":
            tdClasses.push("ready-select");
            break;
        case "past":
        case "last":
        case "blocked":
            tdClasses.push("not-selected");
            break;
        case "busy":
            tdClasses.push("td-selected");
            break;
    }

    if (curTime.status == "free" && props.reserved) {
        //tdClasses.push("td-disabled");
    }
    if (curTime.status == "busy" && props.reservedItem) {
        tdClasses = ["td-disabled"];
    }
    if (curTime.status == "free" && props.reservedItem) {
        tdClasses.push("td-disabled");
    }

    //если есть бронирование
    if (props.reserved.length) {
        const fIdx = props.reserved.indexOf(curTime.stmp);

        if (fIdx == 0) {
            tdClasses = ["td-select"];
            tdRowSpan = 4;

            reservedItemInterval = [];
            props.reservedItem.items.map(item => {
                let idx = props.reserved.indexOf(item.stmp);
                if(idx == 0) {
                    reservedItemInterval.push(item.value);
                } else if(idx == 3) {
                    reservedItemInterval.push(item.last_value);
                }
            });
        } else if (fIdx == 1 || fIdx == 2 || fIdx == 3) {
            removeItem = true;
        }
    }

    let tdItem = (
        <td className={tdClasses.join(" ")} rowSpan={tdRowSpan}>
            {reservedItemInterval &&
            <div className="selected-info">
                <p><b>Выбранное время:</b></p>
                <p>{props.day.date.name} {props.day.date.value}</p>
                <p>{reservedItemInterval.join("-")}</p><a className="cancel-link" onClick={props.onClickCancelReserve} href="#">Отменить</a>
            </div>
            }

            {curTime.canReserve && !reservedItemInterval &&
            <button onClick={e => props.onClickReserve(props.day, curTime)}
                    disabled={props.reserved.length ? true : false}
                    className="btn btn-outline-dark btn-sm btn-select btn-block" type="button"
                    data-toggle="tooltip" data-placement="bottom"
                    title={`${props.day.date.value} ${curTime.value}`}>Забронировать
            </button>
            }

            {curTime.status == "busy" && !props.reservedItem &&
            <div className="td-icon align-center" data-toggle="tooltip" data-placement="bottom" title=""
                 data-original-title="Данное время занято">
                <i className="" data-fa-i2svg="">
                    <svg className="svg-inline--fa fa-info-circle fa-w-16" aria-hidden="true" focusable="false"
                         data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 512 512" data-fa-i2svg="">
                        <path fill="currentColor"
                              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" />
                    </svg>
                </i>
            </div>
            }
        </td>
    );

    if (removeItem) {
        tdItem = null;
    }

    return tdItem;
};

export default CalendarTime;